import React from 'react'
import PropTypes from 'prop-types'

import { ListItemStyle } from './styled'

import TagsImg from '../../assets/tags.png'

export default function Listitems(props) {
  return (
    <ListItemStyle>
      <div className="tag-img">
        <img src={TagsImg} alt="" />
      </div>
      <h3 className="h3 title">
        {props.title}
      </h3>
      <ul className="desc">
        {props.list.map((item, i)=><li key={i}>{item}</li>)}
      </ul>
      <div className='number'>{props.number}</div>
    </ListItemStyle>
  )
}

Listitems.propTypes = {
  number: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  list: PropTypes.array.isRequired,
}
